import React from 'react';
import cn from 'classnames';
import styles from './Navigation.module.scss';

export default function NavSection({ className = null, children, title = null, id = null }) {
  return (
    <div className={cn(styles.section, className)}>
      {title && (
        <div id={id} className={cn('text-small', styles.sectionTitle)}>
          {title}
        </div>
      )}
      {children}
    </div>
  );
}
